import React from "react";
import { fetchProductCategories } from "../fetchData";

const useFetchCategories = () => {
  const [categories, setCategories] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listCategories();
  }, []);

  const listCategories = () => {
    setLoading(true);
    setLoaded(false);
 fetchProductCategories()
      .then(
        (result) => {
          setLoading(false);
          console.log(result);
            setCategories(result?.status ? result.data : []);
        },
        (error) => {
          setCategories([]);
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {categories,loading,loaded};
};

export default useFetchCategories;
